import { Component, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SvgIconComponent } from '../../../components/svg-icon/svg-icon.component';
import { PillSoonComponent } from '../../atoms/pill-soon/pill-soon.component';
import { SvgIcon } from '@services/svg-icon.service';

export interface SideMenuButtonData {
  iconSrc: string;
  title: string;
  showPill?: boolean;
  pillText?: string;
}

/**
 * SideMenuButton component for side menu quick actions
 * Designed for dark theme side menu sections
 * 
 * @example
 * ```html
 * <ds-side-menu-button 
 *   [data]="buttonData"
 *   (click)="onButtonClick()"
 * ></ds-side-menu-button>
 * ```
 */
@Component({
  selector: 'ds-side-menu-button',
  standalone: true,
  imports: [CommonModule, SvgIconComponent, PillSoonComponent],
  templateUrl: './side-menu-button.component.html',
  styleUrls: ['./side-menu-button.component.scss']
})
export class SideMenuButtonComponent {
  readonly SvgIcon = SvgIcon;

  data = input.required<SideMenuButtonData>();
  click = output<void>();

  onClick(): void {
    this.click.emit();
  }
}